import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { Toaster } from "sonner";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
    <Toaster 
      position="top-right" 
      richColors 
      duration={2000}
      pauseWhenPageIsHidden
      closeButton
    />
  </React.StrictMode>,
);
